export const tool = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_11401_25028)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.2208 5.49426C20.0795 8.08258 19.4795 11.0488 17.4198 13.1085C15.4528 15.0756 12.6588 15.7113 10.1569 15.0165L5.78442 19.3889C5.50246 19.6709 5.04246 19.6709 4.76046 19.3889L0.611373 15.2398C0.329412 14.9578 0.329412 14.4978 0.611373 14.2158L4.98382 9.84339C4.28894 7.34146 4.92466 4.5475 6.89178 2.58042C8.95147 0.520734 11.9177 -0.0792264 14.506 0.779535L9.70019 5.58538L10.6966 9.30379L14.415 10.3001L19.2208 5.49426Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_11401_25028">
<rect width="19.2" height="19.2" fill="white" transform="translate(0.399902 0.400391)"/>
</clipPath>
</defs>
</svg>`;
